<template>
  <div class="about-page">
    <PageBanner
      eyebrow="ABOUT"
      background-image="/page/lcbg.jpg"
      :title="{ 'zh-CN': '关于宏邦', 'en-US': 'About Jiangsu Hongbang Transformer' }"
      :subtitle="{
        'zh-CN': '不止变压器，更专注整体输配电解决方案',
        'en-US': 'More than just transformers, we focus on comprehensive power transmission and distribution solutions.'
      }"
    />

    <section class="about-hero">
      <div class="about-hero-left">
        <div class="about-visual" :style="visualStyle">
          <div class="about-visual-overlay"></div>

          <div class="about-visual-copy">
            <div class="about-visual-title" style="max-width: 700px">ABOUT HONGBANG</div>
<!--            <div class="about-visual-lines">-->
<!--              <span></span>-->
<!--              <span></span>-->
<!--              <span></span>-->
<!--              <span></span>-->
<!--              <span></span>-->
<!--            </div>-->
          </div>

          <div class="about-stat-card">
            <strong>{{ $pick(aboutCard[0].title) }}</strong>
            <strong>{{ $pick(aboutCard[0].text) }}</strong>
          </div>
        </div>
      </div>

      <div class="about-hero-right">
        <div class="about-content">
          <div class="about-heading" v-reveal>
<!--            <div class="about-heading-en">ABOUT HONGBANG</div>-->
            <h1>{{ headingText }}</h1>
            <h1 style="max-width: 660px">{{ headingText1 }}</h1>
          </div>

          <div class="about-body" v-reveal>
            <p v-for="paragraph in bodyParagraphs" :key="$pick(paragraph)">
              {{ $pick(paragraph) }}
            </p>
          </div>

          <div class="about-metrics">
            <article
              v-for="item in advantages"
              :key="$pick(item.title)"
              class="about-metric"
              v-reveal
            >
              <strong>{{ $pick(item.title) }}</strong>
              <p>{{ $pick(item.text) }}</p>
            </article>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import PageBanner from "../../components/common/PageBanner.vue";

export default {
  name: "AboutPage",
  components: {
    PageBanner
  },
  computed: {
    visualStyle() {
      return {
        backgroundImage:
          "linear-gradient(180deg, rgba(3, 12, 28, 0.34), rgba(3, 12, 28, 0.62)), url('/about/banner-img.jpg')"
      };
    },
    headingText() {
      return this.locale === "zh-CN"
        ? "不止变压器"
        : "Committed to power manufacturing with products";
    },
    headingText1() {
      return this.locale === "zh-CN"
        ? "更专注整体输配电解决方案"
        : "service and integrated power transmission and distribution solutions.";
    },
    bodyParagraphs() {
      return [
        {
          "zh-CN":
            "江苏宏邦变压器有限公司坐落于江苏徐州工业园区，致力于为客户提供输配电设备与整体电力解决方案。公司聚焦工商业、新能源、市政电网、海外工程全场景输配电需求，不仅提供高品质的电力变压器、干式/油浸式变压器、非晶合金变压器、隔离变压器，还配套生产高低压开关柜、箱式变电站（欧变/美变）、配电箱、电抗器、消弧线圈、矿用及船用特种变压器等全系列输配电设备。同时可承接方案设计、设备集成、安装调试等一站式服务。公司拥有标准化生产基地、全套精密生产检测设备，组建了专业的电气设计团队与工程服务团队，具备完整的输配电系统方案落地能力。依托成熟的技术积累与严苛的品控体系，可为不同行业、不同工况提供定制化、一体化、高适配的整体输配电解决方案。",
          "en-US":
            "Jiangsu Hongbang Transformer Co., Ltd., located in Xuzhou Industrial Park, Jiangsu Province, is committed to providing customers with power transmission and distribution equipment and complete power solutions. The company focuses on full-scenario power transmission and distribution needs across industrial and commercial sectors, new energy, municipal power grids, and overseas projects. It provides not only high-quality power transformers, dry-type/oil-immersed transformers, amorphous alloy transformers, and isolation transformers, but also a full range of power transmission and distribution equipment, including high and low voltage switchgear, prefabricated substations (European/American transformers), distribution boxes, reactors, arc suppression coils, and special transformers for mining and marine applications. The company also provides one-stop services including solution design, equipment integration, installation, and commissioning. With a standardized production base, a full set of precision production and testing equipment, and a professional electrical design and engineering service team, the company possesses the capability to implement complete power transmission and distribution system solutions. Leveraging mature technological accumulation and a rigorous quality control system, it can provide customized, integrated, and highly adaptable overall power transmission and distribution solutions for different industries and operating conditions."
        },
        {
          "zh-CN":
            "公司生产的S11、S13、S15、S20、S22系列，SCB10、SCB11、SCB13、 SCB14、SCB18和SGB系列，10KV、35KV干式&油浸式变压器、非晶合金、有载调压电力变压器等低损耗电力变压器及各种箱式变电站，技术标准严格采用国际GB1094.1、2-1996；GB/T6451-2008，并在同行中率先获得ISO9001质量体系认证证书，江苏宏邦变压器有限公司的营销及服务网络遍及全国，能保证为客户提供快速、优质服务，公司始终秉承“以人为本，科技创新，志在超越”的崇高信念，以可靠的产品质量，优惠的价格，完善的售后服务，精益求精，追求完美，竭力欢迎新老客户垂询合作，愿与广大客户共创双赢的美好明天。",
          "en-US":
            "Our company produces S11, S13, S15, S20, and S22 series transformers, SCB10, SCB11, SCB13, SCB14, SCB18, and SGB series transformers, including 10KV and 35KV dry-type and oil-immersed transformers, amorphous alloy transformers, on-load tap-changing power transformers, and various prefabricated substations. Our technical standards strictly adhere to international standards GB1094.1, 2-1996, and GB/T6451-2008. We were among the first in the industry to obtain ISO9001 quality system certification. Jiangsu Hongbang Transformer Co., Ltd. has a nationwide marketing and service network, ensuring fast and high-quality service for our customers. Adhering to the lofty belief of \"people-oriented, technological innovation, and striving for excellence,\" we are committed to providing reliable product quality, competitive prices, and comprehensive after-sales service. We strive for perfection and welcome inquiries and cooperation from new and old customers. We look forward to creating a win-win future together with our customers."
        },
        {
          "zh-CN":
            "宏邦始终坚持以客户需求为导向，以质量体系为基础，以制造实力和服务响应为支撑，逐步形成集研发、设计、制造、检测、交付与售后于一体的系统化能力。未来，公司将继续围绕绿色能源、电网升级和全球市场合作，不断输出更高标准的变压器产品与解决方案。",
          "en-US":
            "Hongbang continues to develop an integrated capability covering R&D, design, manufacturing, testing, delivery and after-sales support. Looking ahead, the company will keep advancing around green energy, grid upgrades and global cooperation with higher-standard transformer products and solutions."
        }
      ];
    },
    advantages() {
      return [
        {
          title: { "zh-CN": "卓越品质保障", "en-US": "Excellent Quality Assurance" },
          text: { "zh-CN": "以严苛品控体系、精密检测设备和规范工艺流程保障产品稳定运行。", "en-US": "Strict quality control, precision testing and standardized processes support stable product operation." }
        },
        {
          title: { "zh-CN": "全品类供应支持", "en-US": "Full Category Supply Support" },
          text: { "zh-CN": "覆盖变压器、箱式变电站、高低压成套设备等全系列输配电设备。", "en-US": "Covering transformers, prefabricated substations, complete sets and related power transmission and distribution products." }
        },
        {
          title: { "zh-CN": "高效贴心服务", "en-US": "Efficient and Attentive Service" },
          text: { "zh-CN": "提供方案设计、设备集成、安装调试与售后响应等一站式服务。", "en-US": "Providing one-stop service from solution design and integration to commissioning and after-sales response." }
        }
      ];
    },
    aboutCard() {
      return [
        {
          title: { "zh-CN": "源头厂家，实力工厂", "en-US": "Source manufacturer, strong factory" },
          text: { "zh-CN": "整体输配电解决方案", "en-US": "Expert in integrated power transmission and distribution solutions." }
        }
      ];
    }
  }
};</script>

<style scoped>
.about-page {
  background: #ffffff;
}

.about-hero {
  display: grid;
  grid-template-columns: minmax(420px, 43vw) 1fr;
  align-items: stretch;
  min-height: calc(100vh - 280px);
  background: #ffffff;
}

.about-hero-left {
  position: relative;
}

.about-visual {
  position: sticky;
  top: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: calc(100vh - 60px);
  padding: 34px 36px 42px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.about-visual-overlay {
  position: absolute;
  inset: 0;
  background:
    linear-gradient(180deg, rgba(0, 0, 0, 0.08), rgba(0, 0, 0, 0.26)),
    radial-gradient(circle at 72% 34%, rgba(62, 120, 255, 0.25), transparent 20%);
  pointer-events: none;
}

.about-visual-copy,
.about-stat-card {
  position: relative;
  z-index: 1;
}

.about-visual-logo {
  width: 54px;
  height: 54px;
  object-fit: contain;
  margin-bottom: 90px;
}

.about-visual-title {
  max-width: 614px;
  font-size: clamp(56px, 7vw, 110px);
  font-weight: 800;
  line-height: 0.95;
  background: linear-gradient(90deg, #0b56b1 0%, #1a6fcb 50%, #4f64b8 100%);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}

.about-visual-lines {
  margin-top: 62px;
}

.about-visual-lines span {
  display: block;
  width: 100%;
  height: 1px;
  margin-bottom: 108px;
  background: rgba(255, 255, 255, 0.14);
}

.about-stat-card {
  align-self: flex-end;
  width: min(360px, 72%);
  padding: 36px 34px 30px;
  border-radius: 0 34px 0 34px;
  color: #ffffff;
  background: linear-gradient(135deg, #124d98, #1a6fcb 58%, #4f64b8);
  box-shadow: 0 24px 48px rgba(92, 23, 73, 0.26);
}

.about-stat-card strong {
  display: block;
  margin-bottom: 14px;
  font-size: 28px;
  line-height: 1.28;
  font-weight: 700;
}

.about-stat-card span {
  font-size: 15px;
  line-height: 1.75;
}

.about-hero-right {
  background: #ffffff;
}

.about-content {
  max-width: 980px;
  margin: 0 auto;
  padding: 126px 76px 120px;
}

.about-heading-en {
  margin-bottom: 28px;
  font-size: clamp(52px, 7vw, 110px);
  font-weight: 800;
  line-height: 0.92;
  background: linear-gradient(90deg, #114ea1 0%, #1a6fcb 50%, #4f64b8 100%);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}

.about-heading h1 {
  margin: 0;
  max-width: 10em;
  color: #121212;
  font-size: clamp(40px, 4.2vw, 50px);
  line-height: 1.26;
  font-weight: 500;
  letter-spacing: -0.02em;
}

.about-body {
  margin-top: 72px;
}

.about-body p {
  margin: 0 0 28px;
  color: #525c68;
  font-size: 19px;
  line-height: 2.02;
}

.about-metrics {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 24px;
  margin-top: 72px;
}

.about-metric {
  padding: 28px 26px;
  border-top: 3px solid var(--brand-blue);
  background: #f7f9fc;
  box-shadow: 0 18px 38px rgba(18, 54, 110, 0.08);
}

.about-metric strong {
  display: block;
  color: #18202d;
  font-size: 24px;
  font-weight: 700;
  line-height: 1.35;
}

.about-metric p {
  margin: 14px 0 0;
  color: #7b8492;
  font-size: 15px;
  line-height: 1.8;
}

@media (max-width: 1280px) {
  .about-hero {
    grid-template-columns: 40vw 1fr;
  }

  .about-content {
    padding-left: 54px;
    padding-right: 54px;
  }

  .about-metrics {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 980px) {
  .about-hero {
    grid-template-columns: 1fr;
  }

  .about-visual {
    position: relative;
    min-height: 78vh;
  }

  .about-content {
    padding: 72px 18px 84px;
  }

  .about-visual-title,
  .about-heading-en {
    font-size: 54px;
  }

  .about-heading h1 {
    font-size: 36px;
  }

  .about-body {
    margin-top: 44px;
  }

  .about-body p {
    font-size: 16px;
    line-height: 1.9;
  }

  .about-metrics {
    grid-template-columns: 1fr;
    margin-top: 48px;
  }

  .about-stat-card {
    width: min(320px, 100%);
  }
}

@media (max-width: 520px) {
  .about-visual {
    min-height: 460px;
    padding: 92px 18px 28px;
  }

  .about-visual-title,
  .about-heading-en {
    font-size: 40px;
  }

  .about-stat-card {
    padding: 24px 22px 22px;
    border-radius: 0 24px 0 24px;
  }

  .about-stat-card strong {
    margin-bottom: 12px;
    font-size: 24px;
  }

  .about-stat-card span {
    font-size: 15px;
  }

  .about-content {
    padding: 48px 14px 56px;
  }

  .about-heading h1 {
    font-size: 28px;
    max-width: none;
  }

  .about-body {
    margin-top: 32px;
  }

  .about-body p {
    font-size: 14px;
    line-height: 1.85;
  }

  .about-metrics {
    gap: 18px;
  }
}
</style>
